import React, { useState, useEffect } from "react";
import { eventBus } from "../services/eventBusService";
import { useSelector } from "react-redux";
import { crmService } from "../services/crmService";
import {
  //saveCrm,
  //setEditCrm,
  sendSaisie2,
  updateSaisie2,
  updateCrmDateMaj2,
} from "../store/actions/crmAction";
import { Button, Input } from "reactstrap";
import {
  Checkbox,
  FormGroup,
  TextField,
  FormControlLabel,
} from "@material-ui/core";
import moment from "moment";
import { sendEmail } from "../store/actions/userAction";
import { SITE_ADRESS, SENDGRID_MAILFROM1 } from "../config";
//import FormControlLabel from "@mui/material/FormControlLabel";

export function LineForm3({ closeModal, data3, keyData }) {
  // const dispatch = useDispatch();
  const users = useSelector((state) => state.userReducer.users);
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);
  const crmUSoldDeb = useSelector((state) => state.crmReducer.crmUSoldDeb);
  const crmUSoldCred = useSelector((state) => state.crmReducer.crmUSoldCred);
  const [costumerFirstName, setCostumerFirstName] = useState("");
  const [costumerLastName, setCostumerLastName] = useState("");
  //const [costumerTelephone, setcostumerTelephone] = useState("");
  //const [costumerSaisie, setcostumerSaisie] = useState([]);
  //const [costumerDateMaj, setcostumerDateMaj] = useState("");
  //const [costumerId, setcostumerId] = useState("");
  const [listeCaissiers, setListeCaissiers] = useState([]);
  // let listeCaissiers2 = [];

  const [saisieEvent, setSaisieEvent] = useState("");
  const [saisieDebit, setSaisieDebit] = useState("");
  const [saisieCredit, setSaisieCredit] = useState("");
  const [saisieMode, setSaisieMode] = useState("");
  const [saisieDestinataireId, setSaisieDestinataireId] = useState("");
  const [saisieDestinataire, setSaisieDestinataire] = useState("");
  const [saisieDateEvent, setSaisieDateEvent] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [saisieType, setSaisieType] = useState("debit");
  const [saisieSomme, setSaisieSomme] = useState("0");

  //const [bolMail, setBolMail] = useState(0);
  /* const [chosenBox1, setChosenBox1] = useState(0);
  const [chosenBox2, setChosenBox2] = useState(0);
  const [chosenBox3, setChosenBox3] = useState(0);
  const [chosenBox4, setChosenBox4] = useState(0);

  const [colorFlag1, setColorFlag1] = useState(false);
  const [colorFlag2, setColorFlag2] = useState(false);
  const [colorFlag3, setColorFlag3] = useState(false);
  const [colorFlag4, setColorFlag4] = useState(false);*/
  const [focusIdx, setFocusIdx] = useState(0);
  const [sendMailBOL, setSendMailBOL] = useState(false);
  const [justificatif, setJustificatif] = useState(false);
  const [justificatifCode, setJustificatifCode] = useState("");
  useEffect(() => {
    const loadCrmInfos = async () => {
      const crm = await crmService.getById(crmIdxEdited);

      setCostumerFirstName(crm.firstName);
      setCostumerLastName(crm.lastName);
    };

    if (crmIdxEdited) {
      loadCrmInfos();
    }
    if (keyData >= 0 && data3[keyData]) {
      const saisie = data3[keyData];

      setSaisieEvent(saisie.event);
      setSaisieDebit(saisie.debit);
      setSaisieCredit(saisie.credit);
      setSaisieMode(saisie.mode);
      setSaisieDestinataireId(saisie.destinataire_id);
      setSaisieDestinataire(saisie.destinataire);
      setSaisieDateEvent(moment(saisie.dateEvent).format("YYYY-MM-DD"));
      setJustificatif(saisie.justificatif || false);
      setJustificatifCode(saisie.justificatifCode || "");

      if (saisie.credit === "0") {
        setSaisieSomme(saisie.debit);
        setSaisieType("debit");
      } else if (saisie.debit === "0") {
        setSaisieSomme(saisie.credit);
        setSaisieType("credit");
      }
    }

    if (loggedInUser.isManager) {
      const filteredCaissiers = users
        .filter((user) => user.isManager && !user.isAdmin)
        .map((user) => ({
          _id: user._id,
          name: `${user.firstName} ${user.lastName}`,
        }));

      setListeCaissiers(filteredCaissiers);
    }
  }, []);

  const onHandleInputChange = (ev) => {
    const { name, value } = ev.target;

    switch (name) {
      case "saisieType":
        setSaisieType(value);
        setSaisieSomme("0");
        setSaisieDebit("0");
        setSaisieCredit("0");
        break;

      case "event":
        setSaisieEvent(value);
        break;

      case "somme":
        {
          setSaisieSomme(value);
          if (saisieType === "debit") {
            setSaisieDebit(value);
            setSaisieCredit("0");
          } else if (saisieType === "credit") {
            setSaisieCredit(value);
            setSaisieDebit("0");
          }
        }
        break;

      case "saisieDestinataire":
        {
          setSaisieDestinataire(value);
          const selectedCaissier = listeCaissiers.find(
            (el) => el.name === value,
          );
          setSaisieDestinataireId(selectedCaissier ? selectedCaissier._id : "");
        }
        break;

      case "saisieMode":
        setSaisieMode(value);
        break;

      case "dateEvent":
        setSaisieDateEvent(value);
        break;
      case "justificatifCode":
        setJustificatifCode(value);
        break;
      default:
        break;
    }
  };

  const beforeOnFormSubmit = () => {
    onFormSubmit();
  };

  function toggleBolMail() {
    setSendMailBOL((prev) => !prev);
  }
  function toggleJustificatif() {
    setJustificatif((prev) => !prev);
  }
  const onFormSubmit = async () => {
    const hasEvent = saisieEvent.trim() !== "";
    const hasCredit = saisieCredit !== "0";
    const hasDebit = saisieDebit !== "0";
    const requiresInfo = hasCredit; // on exige mode & destinataire uniquement si crédit

    // 1) Validation événement
    if (!hasEvent) {
      return alert("L'événement est obligatoire.");
    }

    // 2) Validation montant (au moins crédit ou débit)
    if (!hasCredit && !hasDebit) {
      return alert("Vous devez saisir un montant de débit ou de crédit.");
    }

    // 3) Si crédit, validation du mode et du destinataire
    if (requiresInfo && (!saisieMode || !saisieDestinataire)) {
      return alert(
        "Pour un crédit, le mode et le destinataire sont obligatoires.",
      );
    }

    // Construction de la saisie
    const newCrmsaisie = {
      ...(keyData != null && keyData >= 0 && data3[keyData]?._id
        ? { _id: data3[keyData]._id }
        : {}),
      crmId: crmIdxEdited,
      event: saisieEvent,
      dateEvent: moment(saisieDateEvent).format(),
      debit: saisieDebit,
      credit: saisieCredit,
      mode: saisieMode,
      destinataire_id: saisieDestinataireId,
      destinataire: saisieDestinataire,
      justificatif,
      justificatifCode,
    };

    if (keyData != null && keyData >= 0) {
      await updateSaisie2(newCrmsaisie);
    } else {
      await sendSaisie2(newCrmsaisie);
    }

    await updateCrmDateMaj2(crmIdxEdited);

    if (sendMailBOL) sendMail();

    closeModal();
  };

  async function sendMail() {
    // 1. Calcul du solde
    const initialBalance = Number(crmUSoldCred) - Number(crmUSoldDeb);
    const tot =
      keyData >= 0
        ? initialBalance.toString()
        : (
            initialBalance -
            Number(saisieDebit) +
            Number(saisieCredit)
          ).toString();

    // 2. Trouver l’utilisateur associé au CRM
    const user = users.find((u) => u.crmId.includes(crmIdxEdited));
    if (!user) {
      console.warn(`Aucun utilisateur trouvé pour le CRM ID ${crmIdxEdited}`);
      return;
    }
    const { email, firstName } = user;

    // 3. Construire le message
    const text = `
    Bonjour ${firstName},
    
    Une nouvelle saisie a été enregistrée pour le donateur : ${costumerFirstName} ${costumerLastName}.
    
    Détails de la saisie :
    - Événement : ${saisieEvent}
    - Date : ${moment(saisieDateEvent).format("DD/MM/YYYY")}
    - Type de saisie : ${saisieType}
    - Montant : ${saisieSomme} shekels
    
    Votre solde est désormais de : ${tot} shekels.
    
    Pour plus de détails, merci de vous connecter à votre compte.
    
    Cordialement,
    Votre équipe
    `;

    const html = `
    <div style="font-family: Arial, sans-serif; color: #333; font-size: 14px; line-height: 1.5;">
      <p>Bonjour <strong>${firstName}</strong>,</p>
      <p>Une nouvelle saisie a été enregistrée pour le donateur : <strong>${costumerFirstName} ${costumerLastName}</strong>.</p>
      <p><u>Détails de la saisie :</u></p>
      <ul>
        <li><strong>Événement :</strong> ${saisieEvent}</li>
        <li><strong>Date :</strong> ${moment(saisieDateEvent).format(
          "DD/MM/YYYY",
        )}</li>
        <li><strong>Type de saisie :</strong> ${saisieType}</li>
        <li><strong>Montant :</strong> ${saisieSomme} shekels</li>
      </ul>
      <p>Votre solde est désormais de : <strong>${tot} shekels</strong>.</p>
      <p>Pour plus de détails, merci de vous connecter à votre compte :</p>
      <p>
        <a href="${SITE_ADRESS}" target="_blank"
           style="display:inline-block;padding:10px 20px;background-color:#007BFF;color:#fff;
                  text-decoration:none;border-radius:5px;">
          Se connecter
        </a>
      </p>
      <p style="margin-top:30px;">Bien cordialement,<br>L’équipe de gestion</p>
    </div>
    `;

    // 4. Préparer et envoyer
    const msg = {
      to: email,
      from: SENDGRID_MAILFROM1, // Votre adresse vérifiée
      subject: "Nouvelle saisie enregistrée",
      text,
      html,
    };

    try {
      await sendEmail(msg);
      console.log(`Email envoyé à ${email}`);
    } catch (err) {
      console.error("Erreur d’envoi de mail :", err);
    }
  }

  const onChangeFocus = (ev) => {
    const { name } = ev.target;
    //console.log(ev);

    setFocusIdx(1);
  };
  if (!loggedInUser) {
    return <div>Loading...</div>;
  }

  return (
    <div className="line-form-container flex">
      <div className="inputs-card flex-col">
        <TextField
          label="Détail de la saisie"
          required
          onFocus={onChangeFocus}
          type="text"
          name="event"
          onChange={onHandleInputChange}
          value={saisieEvent}
        />

        <div className="flex-col">
          <label htmlFor="saisieType">Type de saisie</label>
          <select
            className="select1"
            required
            onFocus={onChangeFocus}
            name="saisieType"
            onChange={onHandleInputChange}
            value={saisieType}
          >
            <option value="debit">Débit (promesse de dons)</option>
            <option value="credit">Crédit (paiement)</option>
          </select>
        </div>

        {saisieType === "credit" && (
          <>
            <div className="flex-col">
              <label htmlFor="saisieDestinataire">Destinataire</label>
              <select
                className="select1"
                onFocus={onChangeFocus}
                name="saisieDestinataire"
                onChange={onHandleInputChange}
                value={saisieDestinataire}
              >
                <option value="">Choisir...</option>
                {listeCaissiers.map((u) => (
                  <option key={u._id} value={u.name}>
                    {u.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex-col">
              <label htmlFor="saisieMode">Mode de paiement</label>
              <select
                className="select1"
                onFocus={onChangeFocus}
                name="saisieMode"
                onChange={onHandleInputChange}
                value={saisieMode}
              >
                <option value="">Choisir...</option>
                <option value="Especes">Espèces</option>
                <option value="Cheque">Chèque</option>
                <option value="Virement">Virement</option>
                <option value="Autre">Autre (PayBox, Bit...)</option>
              </select>
            </div>
          </>
        )}

        <TextField
          label="Somme (NIS)"
          required
          onFocus={onChangeFocus}
          type="number"
          name="somme"
          onChange={onHandleInputChange}
          value={saisieSomme}
        />

        <label className="date-label" htmlFor="dateEvent">
          Date
        </label>
        <TextField
          onFocus={onChangeFocus}
          type="date"
          required
          name="dateEvent"
          onChange={onHandleInputChange}
          value={saisieDateEvent}
        />

        <FormGroup>
          <FormControlLabel
            control={<Checkbox name="email" color="primary" />}
            onChange={toggleBolMail}
            label="Envoyer e‑mail au donateur"
          />
        </FormGroup>
        {saisieType === "credit" && (
          <>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="justificatif"
                    color="primary"
                    checked={justificatif}
                  />
                }
                onChange={toggleJustificatif}
                label="Justificatif émis"
              />
            </FormGroup>

            {justificatif && (
              <TextField
                label="Code justificatif"
                type="text"
                name="justificatifCode"
                onChange={onHandleInputChange}
                value={justificatifCode}
              />
            )}
          </>
        )}
        <div className="btn-modal-container">
          <Button
            className="btn-simple close-modal-btn"
            color="secondary"
            onClick={closeModal}
          >
            Annuler
          </Button>
          <Button
            className="save-btn"
            color="primary"
            variant="contained"
            onClick={beforeOnFormSubmit}
          >
            Enregistrer
          </Button>
        </div>
      </div>
    </div>
  );
}
